module.exports = __webpack_public_path__ + "static/media/collapse-up.b17d6fb3.svg";